import { Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/component/app.layout';
import { DashboardComponent } from './pages/dashboard/dashboard';
import { Notfound } from './pages/plantilla/notfound/notfound';
import { LandingComponent } from './pages/plantilla/landing/landing';

// Guard
import { authGuard } from './Guard/auth.guard';
import { ModalDocumentosRelacionadosComponent } from './shared/components/botoneras/modal-documentos-relacionados/modal-documentos-relacionados.component';
import { SendMailComponent } from './shared/components/general/send-mail/send-mail.component';
import { UnauthorizedComponent } from './shared/components/general/unauthorized/unauthorized.component';
import { ConsultaPqrsComponent } from './pages/pqrs/consulta-externa-pqrs/consulta-pqrs.component';

export const appRoutes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [authGuard],
    runGuardsAndResolvers: 'always',
    children: [
      { path: '', component: DashboardComponent },
      { path: 'documentos-relacionados', component: ModalDocumentosRelacionadosComponent },
      { path: 'configuraciones/parametros', loadChildren: () => import('./pages/uikit/parametros.routes') },
      { path: 'configuraciones/maestros', loadChildren: () => import('./pages/uikit/maestro.routes') },
      { path: 'configuraciones/flujo-doc', loadChildren: () => import('./pages/uikit/flujodoc.routes') },
      { path: 'configuraciones/usuarios', loadChildren: () => import('./pages/uikit/usuarios.routes') },
      { path: 'configuraciones/tabla-retencion-documental', loadChildren: () => import('./pages/uikit/tabla-retencion-documental.route'), },
      { path: 'radicacion', loadChildren: () => import('./pages/uikit/radicacion.routes') },
      { path: 'expediente', loadChildren: () => import('./pages/uikit/expediente.routes') },
      { path: 'reportes', loadChildren: () => import('./pages/uikit/reportes.routes'), },
      { path: 'pqrs', loadChildren: () => import('./pages/uikit/pqrs.routes'), },
      { path: 'pages', loadChildren: () => import('./pages/pages.routes') },
    ],
  },
  {
    path: 'no-autorizado',
    component: AppLayoutComponent, // -> Se requiere mostrar el menu cuando el acceso sea no autorizado
    children: [
      { path: '', component: UnauthorizedComponent },
    ],
  },
  {
    path: 'pqrs-externo',
    component: ConsultaPqrsComponent,
  },
  { path: 'auth', loadChildren: () => import('./pages/auth/auth.routes') },
  { path: 'landing', component: LandingComponent },
  { path: 'send-mail', component: SendMailComponent },
  { path: 'notfound', component: Notfound },  
  { path: '**', redirectTo: '/notfound' },
];
